import { render, staticRenderFns } from "./DevTitle.vue?vue&type=template&id=76b9a0a2&scoped=true&"
import script from "./DevTitle.vue?vue&type=script&lang=js&"
export * from "./DevTitle.vue?vue&type=script&lang=js&"
import style0 from "./DevTitle.vue?vue&type=style&index=0&id=76b9a0a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b9a0a2",
  null
  
)

export default component.exports